import { parse } from "path-browserify";
import eventBus from "../../../core/services/event-bus";
import elementExists from "../../../core/utils/element-exists";
    
const FreightShippingNotice = function( $element = "[cart-freight-shipping-notice]" ){
    const CartService = Shopify.cartService
    let weightThreshold = 250 // 250 lbs
    let priceThreshold = 1000 // $1000
    let priceThresholdMessage = `Your cart is over the __WEIGHT__ pound or the $__PRICE__ threshold for standard shipping. We will contact you for a better shipping rate after you checkout.`
    const $container = document.querySelector( $element );
    let data = {};
  
    
    const checkShippingThrshold = function(){
      let cart = Shopify.cartService.cart;
      if( cart.items.length === 0 ) return;
      let grams = cart.total_weight;
      let price = cart.total_price;
      const show = ( grams >= ( weightThreshold * 454 )  || price >= ( priceThreshold * 100 ) )
      toggleShippingNotice( show  );
    }

    const toggleShippingNotice = function( show = false ){
        if( show ){
            $container.classList.remove('d-none');
            $container.innerHTML = priceThresholdMessage;
        }else{
            $container.innerHTML = '';
            $container.classList.add('d-none');
        }
    }

    if( elementExists( $container )){
        data = {data,...$container.dataset};
        weightThreshold = parseInt( data.weightThreshold );
        priceThreshold = parseInt( data.priceThreshold );
        message = data.priceThresholdMessage;
        priceThresholdMessage = priceThresholdMessage.replace('__WEIGHT__', weightThreshold )
        .replace('__PRICE__', priceThreshold );
  
        // if (typeof (Shopify.theme.cartOnLoad)) {
        //     checkShippingThrshold( )            
        // }

        eventBus.on(eventBus.types.CartUpdated, function ($data) {
            checkShippingThrshold( )            
        })

    }


    let app = {
        data :{
            threshold : 12,
            thresholdType : 'quantity',
            noticePassed : 'You have free shipping!',
            noticeAlmostPassed : 'Add __AMOUNT__ more to get free shipping!',
        },
        init() {
            app.data = {...app.data,...$container.dataset};
            app.data.threshold = parseInt( app.data.threshold );
            if (typeof (Shopify.theme.cartOnLoad)) {
                app.check(Shopify.theme.cartOnLoad)
            }
            eventBus.on(eventBus.types.CartUpdated, function ($data) {
                app.check(CartService.cart)
            })
        },
        check($cart) {
            if( app.data.thresholdType == 'price' ){
                $container.innerHTML = app.priceCheck( $cart );
            }else{
                $container.innerHTML = app.quantityCheck( $cart );
            }
        },
        priceCheck( $cart ){
            let cart_price = ($cart.total_price / 100);
            const excludedProducts = app.data.excludedProducts;
            if (typeof( excludedProducts )!== 'undefined' &&  excludedProducts.length > 0  ) {
                cart_price = 0;
                $cart.items.forEach(item => {
                    if (!excludedProducts.includes(item.product_id)) {
                        cart_price += (item.final_line_price / 100);
                    }
                });
        }
            if (app.data.threshold > cart_price) {
                notice = app.data.noticeAlmostPassed.replace('__AMOUNT__', (app.data.threshold - cart_price).toFixed(2));
            } 
            return notice
        },
        quantityCheck( $cart ){
            let notice = app.data.noticePassed;
            let cart_quantity = $cart.item_count;
            const excludedProducts = app.data.excludedProducts;
            if (typeof( excludedProducts )!== 'undefined' &&  excludedProducts.length > 0  ) {
                $cart.items.forEach(item => {
                    if (!excludedProducts.includes(item.product_id)) {
                        cart_quantity += item.quantity;
                    }
                });
            } 
            if (app.data.threshold > cart_quantity) {
                notice = app.data.noticeAlmostPassed.replace('__AMOUNT__', (app.data.threshold - cart_quantity));
            } 
            return notice
        }
    }

}


export default FreightShippingNotice;